
import Vue from 'vue';

import i18n from '@/i18n';
import api from '@/api';
import { RootActions } from '@/store/types';
import AutocompleteControl, { AutocompletePromise, AutocompleteOption } from '@/components/controls/autocomplete.vue';

export default Vue.extend({
  name: 'TreatmentSelectionControl',
  inject: {
    $validator: '$validator',
  },
  components: {
    AutocompleteControl,
  },
  props: {
    value: {
      type: Number,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: i18n.t('Treatment'),
    },
    label: {
      type: String,
      default: i18n.t('Treatment'),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'treatment',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: undefined,
      internalLabel: '',
      cancelTokenSource: undefined,
      isLoadingTreatment: false,
    };
  },
  computed: {
    autocompleteValue() {
      return {
        label: this.internalLabel,
        value: this.value,
      };
    },
  },
  methods: {
    handleInput(option: AutocompleteOption): void {
      this.internalLabel = option.label;

      let value: number | undefined = Number(option.value);
      if (Number.isNaN(value)) {
        value = undefined;
      }

      if (this.value !== value) {
        this.internalValue = value;
        this.$emit('input', value);
      }
    },
    handleChange(option: AutocompleteOption): void {
      this.internalValue = option.value;
      this.internalLabel = option.label;
      this.$emit('input', Number(option.value));
    },
    loadTreatmentName(): void {
      if (this.value === this.internalValue) {
        return;
      }

      if (!this.value) {
        this.internalLabel = '';

        return;
      }

      this.isLoadingTreatment = true;
      api.treatments
        .get(this.value)
        .then((response) => {
          this.internalLabel = response.data.title;
          this.internalValue = this.value;
          this.isLoadingTreatment = false;
        })
        .catch((error) => {
          this.isLoadingTreatment = false;
          this.$store.dispatch(RootActions.ERROR, error);
          this.internalLabel = '';
          this.internalValue = undefined;
          this.$emit('input', undefined);
        });
    },
    searchTreatment(userInput: string): AutocompletePromise {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel();
        this.cancelTokenSource = undefined;
      }

      if (!userInput) {
        return Promise.resolve({
          results: [],
        });
      }

      this.cancelTokenSource = api.getCancelTokenSource();

      return api.treatments
        .list({ search: userInput }, { cancelToken: this.cancelTokenSource.token })
        .then((response) => {
          return {
            results: response.data.data.map((item) => ({
              label: item.title ?? `#${item.id}`,
              value: item.id,
            })),
          };
        });
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.loadTreatmentName();
      },
    },
  },
});
